import { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatErr } from "@/lib/api";
import { Lock } from "lucide-react";

export default function AdminLoginPage() {
    const { user, login, ready } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    if (ready && user && user.role === "admin") return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        setLoading(true);
        try {
            await login(email, password);
            navigate("/admin");
        } catch (e) {
            setErr(formatErr(e.response?.data?.detail) || "Inloggen mislukt");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-[#0E2C4D] flex items-center justify-center p-6">
            <div className="bg-white w-full max-w-md p-10" style={{borderRadius: 2}} data-testid="admin-login-card">
                <Link to="/" className="flex items-center gap-3 mb-8">
                    <img src="/brand/logo.png" alt="Used Car Selection" className="h-16 w-auto" />
                </Link>

                <div className="label-eyebrow mb-2">Beheerportaal</div>
                <h1 className="text-2xl font-black text-[#0E2C4D] flex items-center gap-2"><Lock className="w-5 h-5" /> Inloggen</h1>
                <p className="text-sm text-slate-500 mt-2">Alleen beheerders.</p>

                <form onSubmit={submit} className="mt-8 space-y-4">
                    <div>
                        <label className="block text-xs font-bold uppercase tracking-wider text-[#0E2C4D] mb-2">E-mail</label>
                        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                               className="w-full border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:border-[#EC6A0A]"
                               style={{borderRadius: 2}} data-testid="admin-login-email" />
                    </div>
                    <div>
                        <label className="block text-xs font-bold uppercase tracking-wider text-[#0E2C4D] mb-2">Wachtwoord</label>
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                               className="w-full border border-slate-300 px-4 py-3 text-sm focus:outline-none focus:border-[#EC6A0A]"
                               style={{borderRadius: 2}} data-testid="admin-login-password" />
                    </div>
                    {err && <div className="text-sm text-red-600" data-testid="admin-login-error">{err}</div>}
                    <button type="submit" disabled={loading} className="ucs-btn-accent w-full justify-center" data-testid="admin-login-submit">
                        {loading ? "Bezig..." : "Inloggen"}
                    </button>
                </form>
            </div>
        </div>
    );
}
